export const formatDatetimeToDatePart = (date: Date | string): string =>
  formatDatetime(date, "dd/MM/yy");
